import { Col, Icon, RoundElement, Row, Text } from 'ui';

const MemberAboutEmptyState = () => (
  <Row align="middle" className="member-about-empty-state" gutter={[0, 'xl']} justify="center">
    <Col span={24} textAlign="center">
      <RoundElement size="medium">
        <Icon color="secondary" icon="list-check-line" />
      </RoundElement>
    </Col>
    <Col span={24} textAlign="center">
      <Text size="large" weight="bold">
        User hasn’t filled any info yet
      </Text>
    </Col>
  </Row>
);

export default MemberAboutEmptyState;
